import React from "react";
import { ProductComp } from "../../Components/ProductPage/Product";

const Product = () => {
  return <ProductComp />;
};

export default Product;
